import styled from 'styled-components';
import { Scrollbar } from 'src/components/general/display/scrollbar';

const MessagePreviewContainer = styled.div`
  background: ${({ theme }) => theme.colors.porcelain};
  border-radius: 10px;
  color: ${({ theme }) => theme.colors.smalt};
  font-family: ${({ theme }) => theme.font.regular};
  font-size: 13px;
  font-weight: 400;
  line-height: 20px;
  padding: 15px;
  white-space: pre-wrap;
  width: 238px;
`;

export const MessagePreview = ({
  message,
  testId,
}: {
  message?: JSX.Element | string;
  testId: string;
}) => {
  return (
    <MessagePreviewContainer data-lgg-id={testId}>
      <Scrollbar>{message}</Scrollbar>
    </MessagePreviewContainer>
  );
};
